import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import PropTypes from "prop-types";
import MuiFormGroup from "@material-ui/core/FormGroup";
import classNames from "classnames";
export class FormGroup extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        id,
        row,
        children,
        className
      } = this.props;
      return /*#__PURE__*/React.createElement(MuiFormGroup, {
        id: id,
        className: classNames("prmbl-formGroup", className),
        row: row
      }, children);
    });
  }
}
_defineProperty(FormGroup, "propTypes", {
  /**
   * The html id
   */
  id: PropTypes.string,
  /**
   * Display group of elements in a compact row
   */
  row: PropTypes.bool,
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string
});
_defineProperty(FormGroup, "defaultProps", {
  row: false
});
export default FormGroup;